<div class="p1 p-l-3 p-r-3 p-t-2 p-b-2 b-a inline-block center _box w-12 col-1"
     [ngClass]="{'_disabled' : disabled, '_selected' : selected, '_border-radius' : borderRadius, '_min-width' : minWidth}">
    <ng-content />
</div>